import { defineStore } from 'pinia';
import * as Sentry from "@sentry/vue";
import axios from 'axios';

const emptyUser = () => ({
    id: null,
    name: "",
    email: null,
    avatar: null,
    company: null,
    authenticated: false,
    permissions: [],
    roles: []
});

export const useUserStore = defineStore('user', {
    state: () => ({
        user: emptyUser(),
        theme: {
            isLight: true
        }
    }),

    actions: {
        initUser() {
            this.user = emptyUser();
        },

        async logout() {
            const response = await axios.post("/logout");
            Sentry.setUser(null);
            this.user = emptyUser();
            return response;
        },

        async readUser() {
            const response = await axios.get("/v1/user");
            let user = response.data.data;
            user.authenticated = true;
            Sentry.setUser({
                id: user.id,
                name: user.name,
                username: user.name,
                email: user.email,
            });
            this.user = user;
            return response.data;
        },

        setAuthenticated() {
            this.user.authenticated = true;
        },

        toggleTheme() {
            this.theme.isLight = !this.theme.isLight;
        }
    },

    persist: true,
});
